/**
 * Customer-facing source labels (frontend mirror of services/displaySourceLabels.js).
 * Internal IDs stay in the API payload; only presentation is remapped.
 */

const FINANCIAL_LABELS = {
  secEdgar: 'SEC filings (EDGAR)',
  secEdgar20F: 'SEC foreign filings (20-F/40-F)',
  eodhd: 'Global fundamentals feed',
  financialModelingPrep: 'Commercial fundamentals feed',
  alphavantage: 'Market data fundamentals',
  'user-supplied': 'Company-provided financials',
  mock: 'Unavailable'
};

const MARKET_LABELS = {
  alphavantage: 'Market prices',
  eodhd: 'Global market prices',
  financialModelingPrep: 'Market prices',
  yahooFinance: 'Market prices',
  yahoo: 'Market prices',
  mock: 'Unavailable'
};

export const displayFinancialSource = (source) => {
  if (!source) return 'N/A';
  return FINANCIAL_LABELS[source] || 'Public financial statements';
};

export const displayMarketSource = (source) => {
  if (!source) return 'N/A';
  return MARKET_LABELS[source] || 'Market prices';
};

export const formatSourcesLine = (financialSource, marketSource) => {
  const financial = displayFinancialSource(financialSource);
  if (!marketSource) return `Financial: ${financial}`;
  return `Financial: ${financial} \u00b7 Market: ${displayMarketSource(marketSource)}`;
};
